import PropTypes from 'prop-types';

import { Label as PlasticLabel } from '@cof/plastic-components';

const labelAttrs = {
    small: {
        color: 'global.grey500',
        fontSize: ['textSmallMobile', null, 'textSmallDesktop'],
        mt: 0
    }
};

const Label = ({ variant, 'data-qa-id': dataQaId, id, ...props }: any) => {
    // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '
    const attrs = labelAttrs[variant] || {};
    return <PlasticLabel data-qa-id={dataQaId || `${id}-label`} p="0" mt="xs" {...attrs} {...props} />;
};

Label.propTypes = {
    'variant': PropTypes.oneOf(['small', 'medium']),
    'data-qa-id': PropTypes.string,
    'id': PropTypes.string
};

Label.displayName = 'Label';
export default Label;
